import {
  CloseButton as CloseButtonBootstrap,
  Modal as ModalBootstrap,
} from 'react-bootstrap';
import styled, { css } from 'styled-components';

export type ModalSizeOption = 'small' | 'medium' | 'large';

const SIZE_MAP: Record<ModalSizeOption, string> = {
  small: '30%',
  medium: '50%',
  large: '70%',
};

const formatHeightValue = (value?: string | number) =>
  typeof value === 'number' ? `${value}px` : value;

export const StyledModal = styled(ModalBootstrap)<{
  $width?: string;
  $size: ModalSizeOption;
}>`
  .modal-dialog {
    width: ${({ $width, $size }) => $width || SIZE_MAP[$size]};
    max-width: ${({ $width, $size }) => $width || SIZE_MAP[$size]};
    margin: 1.75rem auto;
  }

  .modal-content {
    border: none;
    border-radius: 20px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.2);
  }
`;

export const StyledModalHeader = styled(ModalBootstrap.Header)`
  padding: 20px 30px 10px 30px;
  border-bottom: none;
`;

export const StyledModalTitle = styled(ModalBootstrap.Title)`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 1.125rem;
`;

export const TitleIcon = styled.span.attrs({ className: 'material-icons' })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 1.25rem;
  color: #0a58ca;
  font-size: 1.5rem;
`;

export const StyledModalBody = styled(ModalBootstrap.Body)<{
  $maxBodyHeight?: string | number;
}>`
  padding: 30px;
  ${({ $maxBodyHeight }) =>
    $maxBodyHeight !== undefined &&
    css`
      max-height: ${formatHeightValue($maxBodyHeight)};
      overflow-y: auto;
    `}
`;

export const ClearCloseButton = styled(CloseButtonBootstrap)`
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 2;
`;
